import { render, staticRenderFns } from "./PostalCodesConfigs.vue?vue&type=template&id=4bac6411&"
import script from "./PostalCodesConfigs.vue?vue&type=script&lang=js&"
export * from "./PostalCodesConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports